// 快讯日历接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default axios => ({
  init: (params = {}, useCache) => get(axios, `${testwikidatacenter}/wikifxweb-v1/download/index/init-v1`, params, true),
  homeClientInit: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/download/index/init-v1`, params)
})
